module.exports = __webpack_public_path__ + "img/fiat-2012-calendar-teaser-03.504ac604.jpg";